import { defineUrlIcon } from '@carnica/graphics';
export var defineIconFromUrl = function defineIconFromUrl(url) {
  return defineUrlIcon({
    url: url,
    ratio: 1
  });
};